<h1 class="page-header"><mat-icon slot="start">task</mat-icon> Aktivity</h1>
@if (loading) {
  <div style="width: 100%;text-align: center;">
    <div style="display:flex;justify-content: center;align-items: center"><mat-spinner></mat-spinner></div><br>
    <p>Načítání</p>
  </div>
}
@else {
  <div class="content">
    @if (!activities) {
      <p>Momentálně máte splněny všechny aktivity.</p>
    }
    @for (activity of activities; track activity.aid) {



      <mat-card class="activity-card">
        @if (activity.available == true) {
          <mat-card-header class="activity-number in_progressText">
            {{activity.params.order}}
          </mat-card-header>
        }
        @else {
          <mat-card-header class="activity-number {{activity.state}}Text">
            {{activity.params.order}}
          </mat-card-header>
        }
        <mat-card-header class="activity-eta">
          ~{{activity.params.eta}}
        </mat-card-header>
        <mat-card-title class="activity-title">
          <strong>{{activity.name}}</strong>
        </mat-card-title>
        <mat-card-content class="card-content">
          @if (activity.available != true && activity.state != "complete" && activity.state != "in_progress") {
            <br>
            @if (activity.available == false) {
              <p>Předchozí krok nedokončen</p>
            }
            @else {

              <p><mat-icon slot="start">hourglass_empty</mat-icon>Bude dostupné {{activity.available | date : "d.M.YYYY" }}</p>
            }
          }
        </mat-card-content>
        <mat-card-actions class="card-action">
          @if (activity.state == "complete") {
            @if (activity.type == 2 || activity.type == 4 || activity.type == 5) {
              <button class="complete accessBtn" mat-flat-button (click)="goToActivity(activity.aid)"><mat-icon iconPositionEnd class="enterIcon" slot="end">arrow_right</mat-icon> Spustit znovu</button>
            }
            @else {
              <button disabled class="complete accessBtn" mat-flat-button><mat-icon slot="start">check</mat-icon> Hotovo</button>
            }
          }@else if (activity.state == "in_progress"){
            <button class="in_progress accessBtn" mat-flat-button (click)="goToActivity(activity.aid)"><mat-icon iconPositionEnd class="enterIcon" slot="end">arrow_right</mat-icon> Spustit</button>
          }@else if (activity.available == true) {
            <button class="in_progress accessBtn" mat-flat-button (click)="goToActivity(activity.aid)"><mat-icon iconPositionEnd class="enterIcon" slot="end">arrow_right</mat-icon> Spustit</button>
          } @else if (activity.available != true) {
            <button disabled class="not_started accessBtn" mat-flat-button><mat-icon iconPositionEnd class="enterIcon" slot="end">arrow_right</mat-icon> Spustit</button>
          }
        </mat-card-actions>
      </mat-card><br>
    }
  </div>
}
